export default "__VITE_ASSET__kHL4B80R__"